module.exports = __webpack_public_path__ + "947edc055e0c78ffc93fcf7cffa61f43.jpg";


//////////////////
// WEBPACK FOOTER
// ./design/photos/objekte/Ruoff_091203_0005_w.jpg
// module id = 364
// module chunks = 0